import Segment, { trackEvent } from '@redux-beacon/segment';
import { createMiddleware } from 'redux-beacon';

// Actions
import { ActionTypes } from '../cards/actions/tracking';

// Leaving this here as example in case action needs to be extracted or state manipulated
// const trackCardEvent = trackEvent((action, prevState, nextState) => {
//   const { payload } = action;
//   // if (prevState.cards.project.uuid !== nextState.cards.project.uuid) {
//   //   console.log('prevState', prevState.cards.project.uuid);
//   //   console.log('nextState', nextState.cards.project.uuid);
//   // }
//   // payload consists of { name, properties, options }, last two are optional
//   return { ...payload };
// });

const cardsEventsMap = {
  [ActionTypes.TRACK_CARD_EVENT]: trackEvent(action => ({ ...action.payload })),
};

const segmentMiddleware = createMiddleware(cardsEventsMap, Segment());

export default segmentMiddleware;



// WEBPACK FOOTER //
// ./src/store/eventsTrackingMiddleware.js